import { type StyleConfigProps, type VisibilityElementProps } from '@blaze-runtime/engine-domain';
import {
  type BorderRadiusValue,
  type CanvasElementPropertiesWithData,
  type CollapsibleContainerBehaviorModel,
  type ElementHorizontalAlignment,
  type ElementTitleStyleProps,
  type LabelIconAlignment,
  type PropertiesConfigInputColorModel,
  type PropertiesConfigInputSpacingAndAlignmentModel,
  type PropertiesConfigInputVisualEffectModel,
} from '@blaze-shared/elements-domain';
import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

export const INITIAL_SLOT_ID = '0';
export const DEFAULT_WIDTH = 500;
export const DEFAULT_HEIGHT = 320;

type PropsModel = CanvasElementPropertiesWithData & StyleConfigProps & VisibilityElementProps;

export type CollapsibleContainerPropsModel = PropsModel & {
  content: {
    header: {
      align: ElementHorizontalAlignment;
      chevron: string;
      icon?: string;
      iconPosition?: LabelIconAlignment;
      iconColor?: PropertiesConfigInputColorModel;
      reverseChevron: boolean;
      showChevron: boolean;
      title: string;

      /**
       * Used for properties editor style title subsection.
       * Not used inside the component.
       */
      enabled: boolean;
    };
    behavior: CollapsibleContainerBehaviorModel;
  };
  style: {
    general: {
      offset: PropertiesConfigInputSpacingAndAlignmentModel;
    };
    titleBlock: ElementTitleStyleProps;
    container: {
      outline: PropertiesConfigInputColorModel;
      outlineWidth: ValueWithUnitOfMeasure;
      radius: BorderRadiusValue;
      visualEffect?: PropertiesConfigInputVisualEffectModel;
    };
    header: {
      title: PropertiesConfigInputColorModel;
      icon: PropertiesConfigInputColorModel;
      fill: PropertiesConfigInputColorModel;
    };
    content: {
      divider: PropertiesConfigInputColorModel;
      fill: PropertiesConfigInputColorModel;
    };
  };
};
